import { connect } from 'react-redux';
import Hamburger from './Hamburger';

const mapStateToProps = state => ({

});

const mapDispatchToProps = {
  
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Hamburger);
